import { ButtonProps } from '@mui/material/Button';
import { ReactNode, MouseEvent, useState } from 'react';
import useApplication from '../../hooks/useApplication.hooks';
import Button from './StandardButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
interface CloseButtonProps extends ButtonProps {
    children?: ReactNode;
}

const CloseButton = (props: CloseButtonProps) => {
    const { children, ...restProps } = props;
    const { isLoading, setIsLoading } = useApplication();

    return (
        <Button showLoading={true} {...restProps} icon={<CloseIcon />}>
            {children}
        </Button>
    );
};

export default CloseButton;
